"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupComputeValidators = void 0;

var UNOWNED_REPLICA_SET_1 = require("./UNOWNED_REPLICA_SET");

var UNOWNED_POD_1 = require("./UNOWNED_POD");

var MISSING_HPA_APP_1 = require("./MISSING_HPA_APP");

var POD_LIFECYCLE_1 = require("./POD_LIFECYCLE");

var POD_STATUS_NOT_SCHEDULED_1 = require("./POD_STATUS_NOT_SCHEDULED");

var POD_STATUS_NOT_CONTAINERS_READY_1 = require("./POD_STATUS_NOT_CONTAINERS_READY");

var POD_STATUS_NOT_INITIALIZED_1 = require("./POD_STATUS_NOT_INITIALIZED");

var POD_STATUS_NOT_READY_1 = require("./POD_STATUS_NOT_READY");

var POD_STATUS_OTHER_CONDITION_1 = require("./POD_STATUS_OTHER_CONDITION");

function setupComputeValidators(builder) {
  UNOWNED_REPLICA_SET_1.setupUNOWNED_REPLICA_SET(builder);
  UNOWNED_POD_1.setupUNOWNED_POD(builder);
  MISSING_HPA_APP_1.setupMISSING_HPA_APP(builder);
  POD_LIFECYCLE_1.setupPOD_LIFECYCLE(builder);
  POD_STATUS_NOT_SCHEDULED_1.setupPOD_STATUS_NOT_SCHEDULED(builder);
  POD_STATUS_NOT_CONTAINERS_READY_1.setupPOD_STATUS_NOT_CONTAINERS_READY(builder);
  POD_STATUS_NOT_INITIALIZED_1.setupPOD_STATUS_NOT_INITIALIZED(builder);
  POD_STATUS_NOT_READY_1.setupPOD_STATUS_NOT_READY(builder);
  POD_STATUS_OTHER_CONDITION_1.setupPOD_STATUS_OTHER_CONDITION(builder);
}

exports.setupComputeValidators = setupComputeValidators;